module.exports = __webpack_public_path__ + "img/eye-low-vision.a2b08511.svg";